<template>
  <div>
    <div class="modal modal--welcomeback modal--zero-balance " id="modal_cookies">
      <div class="modal__content modal_welcome modal_cont">
        <div class="modal__header">
        </div>
        <div class="modal__body">
          <h1>{{ getTranslations.visitor_modal_cookies_title }}</h1>
          <p class="upper_section_modal">{{ getTranslations.visitor_modal_cookies_text }} <span class="make_it_bold">
                <a :href="getTranslations.visitor_modal_cookies_terms_link" target="_blank">{{ getTranslations.visitor_modal_cookies_terms_text }}</a>  </span> {{ getTranslations.visitor_modal_cookies_after_terms_text }} </p>
          <div class="modal_two_btns">
            <a class="ti_btn--main" @click.prevent="cookiesStorage(true)" @click="$emit('close')" style="cursor: pointer">{{ getTranslations.visitor_modal_cookies_accept }}</a>
          </div>
          <div class="modal_two_btns">
            <a class="ti_btn--second" @click.prevent="cookiesStorage(false)" @click="$emit('close')" style="cursor: pointer">{{ getTranslations.visitor_modal_cookies_decline }}</a>
          </div>
        </div>
        <div class="modal__footer">
        </div>
      </div>
    </div>
    <div class="modal-overlay"></div>
  </div>
</template>

<script>
import { mapGetters, mapState } from 'vuex';

export default {
  name: 'cookies-pop-up',
  created() {
    this.showModal();
  },
  methods: {
    cookiesStorage(cookiesEnabled) {
      if (cookiesEnabled) {
        localStorage.setItem('cookiesEnabled', cookiesEnabled);
      }
      // eslint-disable-next-line
      console.log('cookiesEnabled', cookiesEnabled);
    },
    showModal() {
      /* eslint-disable */
      const vm = this;
      this.$nextTick(() => {
        // open modal
        $('.modal,.modal-overlay').fadeIn(200);
        // show/hide modal
        $('.modal-close, .modal-overlay').click(function () {
          vm.$emit('close');
          $('#loading').fadeOut();
        });
      });
      /* eslint-enable */
    },
  },
  computed: {
    ...mapState('common', [
      'multiOperatorInfo',
    ]),
    ...mapGetters('i18n', [
      'getTranslations',
    ]),
  },
};
</script>




// WEBPACK FOOTER //
// src/components/home/modals/CookiesPopUp.vue